import { createStore } from 'jotai';

export const JOTAI_STORE = createStore();
